module.exports = __webpack_public_path__ + "img/default-browse-vehicles-lincoln.04f03a48.png";